import { render, staticRenderFns } from "./ViewAttachmentForm.vue?vue&type=template&id=769708da&scoped=true&"
import script from "./ViewAttachmentForm.vue?vue&type=script&lang=js&"
export * from "./ViewAttachmentForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewAttachmentForm.vue?vue&type=style&index=0&id=769708da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769708da",
  null
  
)

export default component.exports